import { render, staticRenderFns } from "./DynamicAttributeDefault.vue?vue&type=template&id=19104e02&"
import script from "./DynamicAttributeDefault.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports